import { CButton } from '@coreui/react';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { callTokenApi } from '../../../../apiCaller';
import {
     API_CLIENT_EXPORT_REPORTING_EXPLORER,
     CHECKLIST_OPTION,
     DEFAULT_DATE_FORMAT,
     EXCLUDE_CHECK_LIST_OPERATOR_OPTION,
     EXPORT_TYPE,
     PLATFORM_ACCOUNT_STATUSES,
     REPORT_NAMES,
     REPORT_TYPE,
} from '../../../../constants';
import { exportToCSV2, exportVisibleReport, generateCustomDimensionName } from '../../../../utils';
import { getCustomPropertiesReport, getDefaultFieldReport, handleChangeColSort, handleChangeColSortDimension } from '../../../../utils/UtilReport';
import { EventExplorerContext } from './EventExplorer';

const ExportReport = () => {
     const {
          filterMetric,
          filterDimensions,
          filterProperties,
          reportName,
          sort,
          filterEvent,
          itemsPerPage,
          offSet,
          scoped,
          reportType,
          conversionNameMetric,
          externalObjectMetric,
          conversionName,
          showData,
          dateRangeConfig,
          customDimensionInfo,
          newProperties: propertiesAll,
          newDimensions: dimensionsAll,
          recordProfile,
          isLoading,
          maxStepForm,
          eCoItemCategories,
          weight,
          attributeBeforeReload,
          metricsStepForm,
          reportData,
          tempReport,
          reportCompare,
          listSegmentReportApply,
          utmArray,
          isWebConversion,
          dimensionEvents,
          customObjectSF,
          listDynamicFields,
          unRelated,
          intentProperties,
          objectID,
          handleGetOption,
          setTempReport,
          setReloadTable,
          exportReportTemp,
          setExportReportTemp,
     } = useContext(EventExplorerContext);
     const dateRangeReports = useSelector((state) => state.subscriber.dateRangeReports);
     const intentCellState = useSelector((state) => state.subscriber.intentCellState);
     const metricDynamic = listDynamicFields?.metrics?.length > 0 ? listDynamicFields?.metrics : [];
     const customExternalObjectReport = useSelector((state) => state.subscriber.customExternalObjectReport);
     const {dimensionsDefault, propertiesDefault, metricsDefault} = getDefaultFieldReport({ reportType, reportName, scoped, weight, utmArray, properties: propertiesAll, dimensions: dimensionsAll, objectID, eCoItemCategories, customExternalObjectReport, handleGetOption });
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const user = useSelector((state) => state.theme.user);
     const [disableExport, setDisableExport] = useState(false);
     const segments = listSegmentReportApply;

     useEffect(() => {
          if (
               activeAccount.platformAccountStatus !== PLATFORM_ACCOUNT_STATUSES.SANDBOX ||
               localStorage.getItem('llByPassSandbox') ||
               window.location.search.includes('bypass-sandbox=1')
          ) {
               setDisableExport(isLoading);
          } else {
               setDisableExport(true);
          }
     }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleOrderCol = (arr, arrFilter) => {
          const newArr = [];
          arr.forEach((item) => {
               if (arrFilter.some((el) => el.value === item.key)) {
                    newArr.push(item.key);
               }
          });
          return newArr;
     };

     const handleExportCSV = (typeExport) => {
          if (!showData) {
               return;
          }

          const newDateRange = {
               selection: {
                    startDate: dateRangeReports.selection.startDate.format(DEFAULT_DATE_FORMAT),
                    endDate: dateRangeReports.selection.endDate.format(DEFAULT_DATE_FORMAT),
               },
          };

          if (dateRangeReports.compare) {
               newDateRange.compare = {
                    startDate: dateRangeReports.compare.startDate.format(DEFAULT_DATE_FORMAT),
                    endDate: dateRangeReports.compare.endDate.format(DEFAULT_DATE_FORMAT),
               };
          }
          if (dateRangeConfig.dateScope) {
               newDateRange.dateScope = dateRangeConfig.dateScope;
          }
          const newProperties = attributeBeforeReload.properties;
          const newMetric = attributeBeforeReload.metrics;
          let headerColumn = [...filterDimensions.map(el => ({ ...el, type: 'dimension' })), ...filterProperties.map(el => ({ ...el, type: 'property' })), ...filterMetric.map(el => ({ ...el, type: 'metric' }))];

          const newFilter = filterEvent.map((item) => {
               const newItem = { ...item };

               if (item.operator === CHECKLIST_OPTION.value || item.operator === EXCLUDE_CHECK_LIST_OPERATOR_OPTION.value) {
                    newItem.value = item.value && Array.isArray(item.value) ? [...item.value].map((el) => el.value) : [];
               }
               delete newItem['optionsOperator'];
               return newItem;
          });
          const filterFields = {
               metrics: handleChangeColSort([...metricsDefault, ...conversionNameMetric, ...metricsStepForm, ...externalObjectMetric, ...metricDynamic], filterMetric).map((i) => i.key),
               properties: handleOrderCol(propertiesDefault, filterProperties),
               dimensions: handleOrderCol(dimensionsDefault, filterDimensions),
          };

          let bodyData = {
               reportName,
               accountId: activeAccount.id,
               dateRanges: newDateRange,
               metrics: handleChangeColSort([...conversionNameMetric, ...metricsDefault, ...metricsStepForm, ...externalObjectMetric, ...metricDynamic], filterMetric).map((i) => i.key),
               properties: handleOrderCol(propertiesDefault, filterProperties),
               dimensions: handleChangeColSortDimension([...dimensionsDefault], filterDimensions).map((i) => i.key),
               filter: newFilter,
               sort: sort,
               headerColumn: headerColumn,
               email: user.email,
               firstName: user.firstName,
               pathName: window.location.pathname,
               scoped: scoped,
               reportType: reportType,
               conversionName: conversionName.filter((conversion) => newMetric.some((metric) => metric.includes(conversion.convId))),
               eCommerceName: conversionName.filter((conversion) => newMetric.includes(conversion.value) && conversion.label.includes('Ecommerce')),
               customProperties: getCustomPropertiesReport(customDimensionInfo, newProperties),
               customDimensions: getCustomPropertiesReport(customDimensionInfo, dimensionsDefault),
               isCompare: dateRangeConfig.comparePeriod,
               recordProfile,
               limit: itemsPerPage,
               offset: offSet,
               weight,
               segments,
               temp: tempReport.temp,
               tempCompare: tempReport.tempCompare,
               customObjectSF,
               unRelated,
               intentProperties: intentProperties.filter((pro) => filterProperties.some((el) => generateCustomDimensionName(`${pro?.name}_intent`) === el.value)),
          };
          if (newDateRange.compare && (!reportType || reportName === REPORT_NAMES.ECOMMERCE_PURCHASE_TRANSACTION || reportName === REPORT_NAMES.SALES_CONVERSION_EVENTS || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType))) {
               delete newDateRange.compare;
               bodyData.isCompare = false;
          }
          if (reportName === 'formCategoryReport') {
               bodyData.maxStepForm = maxStepForm;
          }

          if (reportName === 'conversionEvents') {
               bodyData.isWebConversion = isWebConversion;
               bodyData.dimensionEvent = dimensionEvents;
          }

          if ([REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)) {
               bodyData.listDynamicFields = listDynamicFields;
          }

          setDisableExport(true);

          // For handle rerun intent property
          if (Object.keys(intentCellState).length > 0 && bodyData.intentProperties.length > 0) {
               if (exportReportTemp.isWaiting) {
                    bodyData.temp = exportReportTemp.temp;
                    bodyData.tempCompare = exportReportTemp.tempCompare;
                    setExportReportTemp({ temp: '', tempCompare: '', isWaiting: false, exportType: '' });
               } else {
                    setExportReportTemp({ temp: '', tempCompare: '', isWaiting: true, exportType: typeExport });
                    setTempReport({ temp: '', tempCompare: '' });
                    setReloadTable((prev) => !prev);
                    return;
               }
          }

          if (typeExport === EXPORT_TYPE.EXPORT_ALL_PAGE) {
               callTokenApi(API_CLIENT_EXPORT_REPORTING_EXPLORER, 'POST', bodyData);
               setTimeout(() => {
                    toast.success('Your file has been emailed, it may take a few minutes to send, please check your email');
                    setDisableExport(false);
               }, 3000);
          } else {
               const tempFileName = `${reportName}.csv`;
               const csvString = exportVisibleReport({
                    data: reportData,
                    filterFields,
                    newProperties,
                    newMetric,
                    headerColumn,
                    reportName,
                    reportCompare,
                    isCompare: bodyData.isCompare,
                    reportType,
                    segments,
                    newDateRange,
                    intentProperties,
                    customProperties: getCustomPropertiesReport(customDimensionInfo, newProperties),
               });
               if (csvString) {
                    exportToCSV2(csvString, tempFileName);
               }
               setDisableExport(false);
          }
     };

     useEffect(() => {
          if (exportReportTemp.isWaiting && (exportReportTemp.temp || exportReportTemp.tempCompare)) {
               handleExportCSV(exportReportTemp.exportType);
          }
     }, [exportReportTemp.temp, exportReportTemp.tempCompare]); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <div className="export-report filter-report d-flex justify-content-end align-items-center">
               <CButton className="filter-button mr-2" disabled={disableExport} onClick={() => handleExportCSV(EXPORT_TYPE.EXPORT_ALL_PAGE)}>
                    Export the entire data set
               </CButton>
               <CButton className="filter-button" disabled={disableExport} onClick={() => handleExportCSV(EXPORT_TYPE.EXPORT_A_PAGE)}>
                    Export Visible Page
               </CButton>
          </div>
     );
};

export default ExportReport;
